// https://github.com/alexfoxy/laxxx
import lax from 'lax.js'
export default () => {
    window.onload = function() {
        lax.setup(); // init

        const updateLax = () => {
            lax.update(window.scrollY);
            window.requestAnimationFrame(updateLax);
        };

        window.requestAnimationFrame(updateLax);
    };
}



// WEBPACK FOOTER //
// ../src/scripts/modules/parallax.js